import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Masonry from '@mui/lab/Masonry';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';

import Link from 'next/link';
import { articleLink, count, getCanonicalSlug, isDefined, productLink } from '../../config/helpers';
import dynamic from 'next/dynamic';
import { Fragment } from 'react';

const BoxContainer = dynamic(() => import('../Reusables/BoxContainer'));

const Title = ({children}) => (
    <Typography className="mb-2 mt-2 fw-bold" variant="h5" component="h5">{children}</Typography>
)

const Sitemap = (props) => {
    const {
        static_pages,
        articles,
        casestudies,
        news,
        guides,
        blogs,
        products,
        sitemap_categories,
        places,
        areas,
        venues
    } = props;

    const urlLink = (data) => {
        return getCanonicalSlug({canonical_category_slug: data.canonical_category_slug, section_slug: data.section_slug});
    }

    return (
        <BoxContainer className="mt-2">

        <Box>
            <Masonry  columns={{xs: 1, sm: 2, md:3, lg: 4}}>
                {isDefined(static_pages) && count(static_pages) > 0 && <Box>
                    <Title>Pages</Title>
                    <ul>
                        {static_pages.map((link, idx) => (
                            <li key={idx}>
                                <Link href={`/${link.slug}`}>
                                    <IconButton color="primary">
                                        <ArrowCircleRightIcon/>
                                    </IconButton>
                                    {link.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </Box>}

                {isDefined(casestudies) && count(casestudies) > 0 && <Box>
                    <Title>Case Studies</Title>
                    <ul>
                        {casestudies.map((casestudy, idx) => (
                            <li key={idx}>
                                <Link href={articleLink(casestudy.type, casestudy.date, casestudy.slug)}>
                                    <IconButton color="primary">
                                        <ArrowCircleRightIcon/>
                                    </IconButton>
                                    {casestudy.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </Box>}

                {isDefined(articles) && count(articles) > 0 && <Box>
                    <Title>Articles</Title>
                    <ul>
                        {articles.map((article, idx) => (
                            <li key={idx}>
                                <Link href={articleLink(article.type, article.date, article.slug)}>
                                    <IconButton color="primary">
                                        <ArrowCircleRightIcon/>
                                    </IconButton>
                                    {article.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </Box>}

                {isDefined(news) && count(news) > 0 && <Box>
                <Title>News</Title>
                <ul>
                    {news.map((newsArticle, idx) => (
                        <li key={idx}>
                            <Link href={articleLink(newsArticle.type, newsArticle.date, newsArticle.slug)}>
                                <IconButton color="primary">
                                    <ArrowCircleRightIcon/>
                                </IconButton>
                                {newsArticle.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            </Box>}

            {isDefined(guides) && count(guides) > 0 && <Box>
                <Title>Guides</Title>
                <ul>
                    {guides.map((guide, idx) => (
                        <li key={idx}>
                            <Link href={articleLink(guide.type, guide.date, guide.slug)}>
                                <IconButton color="primary">
                                    <ArrowCircleRightIcon/>
                                </IconButton>
                                {guide.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            </Box>}

            {isDefined(blogs) && count(blogs) > 0 && <Box>
                <Title>Blog</Title>
                <ul>
                    {blogs.map((blog, idx) => (
                        <li key={idx}>
                            <Link href={articleLink(blog.type, blog.date, blog.slug)}>
                                <IconButton color="primary">
                                    <ArrowCircleRightIcon/>
                                </IconButton>
                                {blog.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            </Box>}

            {isDefined(products) && count(products) > 0 && <Box>
                <Title>Products</Title>
                <ul>
                    {products.map((product, idx) => (
                        <li key={idx}>
                            <Link href={productLink(urlLink(product), product.product_slug)}>
                                <IconButton color="primary">
                                    <ArrowCircleRightIcon/>
                                </IconButton>
                                {product.product_name}
                            </Link>
                        </li>
                    ))}
                </ul>
            </Box>}

            {isDefined(sitemap_categories) && count(sitemap_categories) > 0 && <Box>
                <Title>Categories</Title>
                <ul>
                    {sitemap_categories.map((side_menu_category, idx) => (
                        <Fragment key={idx}>
                            <li>
                                <Link href={`/${side_menu_category.slug}`}>
                                    <IconButton color="primary">
                                        <ArrowCircleRightIcon/>
                                    </IconButton>
                                    {side_menu_category.name}
                                </Link>
                            </li>
                            <ul>
                                {count(side_menu_category.sons) > 0 && side_menu_category.sons.map((son, index) => (
                                    <li className="pl-4" key={index}>
                                        <Link href={`/${son.slug}`}>
                                            <IconButton color="primary">
                                                <ArrowCircleRightIcon/>
                                            </IconButton>
                                            {son.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </Fragment>
                    ))}
                </ul>
            </Box>}
            
            {isDefined(places) && count(places) > 0 && <Box>
                <Title>Places</Title>
                <ul>
                    {places.map((place, idx) => (
                        <li key={idx}>
                            <Link href={`/place/${place.slug}`}>
                                <IconButton color="primary">
                                    <ArrowCircleRightIcon/>
                                </IconButton>
                                {place.name}
                            </Link>
                        </li>
                    ))}
                </ul>
            </Box>}
            
            {isDefined(areas) && count(areas) > 0 && <Box>
                <Title>Area</Title>
                <ul>
                    {areas.map((area, idx) => (
                        <li key={idx}>
                            <Link href={`/area/${area.slug}`}>
                                <IconButton color="primary">
                                    <ArrowCircleRightIcon/>
                                </IconButton>
                                {area.name}
                            </Link>
                        </li>
                    ))}
                </ul>
            </Box>}
            
            {isDefined(venues) && count(venues) > 0 && <Box>
                <Title>Venues</Title>
                <ul>
                    {venues.map((venue, idx) => (
                        <li key={idx}>
                            <Link href={`/venue/${venue.slug}`}>
                                <IconButton color="primary">
                                    <ArrowCircleRightIcon/>
                                </IconButton>
                                {venue.name}
                            </Link>
                        </li>
                    ))}
                </ul>
            </Box>}
                
            </Masonry>
        </Box>
            
        </BoxContainer>
    )
}

export default Sitemap